// extracted by mini-css-extract-plugin
export default {"imageContainer":"ScrollHandler_imageContainer__Tjf5P"};